// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  margin-bottom: var(--spacing-regular);
}
.hero .VertCarousel-Container {
  padding-bottom: var(--spacing-small);
}
@media screen and (min-width: 1200px) {
  .hero .VertCarousel-Container {
    max-height: 407px;
  }
}
@media screen and (min-width: 576px) and (max-width: 1200px) {
  .hero .VertCarousel-Container {
    max-height: 407px;
  }
}
.hero .ant-carousel {
  line-height: 0;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners {
  padding-top: var(--spacing-small);
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners a {
  display: flex !important;
  justify-content: center;
  width: 100vw !important;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners .ant-image .ant-image-img,
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners .lazy-image {
  height: auto !important;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners .lazy-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .mobile-banners {
  margin: var(--spacing-small) 0;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .mobile-banners .ant-image .ant-image-img,
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .mobile-banners .lazy-image {
  height: 160px;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .mobile-banners a {
  display: flex !important;
  justify-content: center;
  width: 100vw !important;
}
.hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .mobile-banners .lazy-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 1600px) {
  .hero .ant-carousel .vert-carousel .slick-list .slick-track .slick-slide .desktop-banners .image {
    border-radius: var(--border-radius-base);
  }
}
@media screen and (max-width: 576px) {
  .hero .ant-carousel .vert-carousel .slick-list {
    max-height: 180px;
  }
}
.hero .ant-carousel .vert-carousel .slick-dots {
  display: flex;
  gap: 8px;
}
.hero .ant-carousel .vert-carousel .slick-dots.slick-dots-bottom {
  margin-bottom: -30px;
}
.hero .ant-carousel .vert-carousel .slick-dots.slick-dots-bottom li.slick-active {
  margin-right: 30px;
}
.hero .ant-carousel .vert-carousel .slick-dots.slick-dots-bottom li.slick-active button {
  width: 56px;
  height: 4px;
  border-radius: 8px;
  margin-right: 20px;
  background-color: var(--color-detached);
}
.hero .ant-carousel .vert-carousel .slick-dots.slick-dots-bottom li button {
  width: 21px;
  height: 4px;
  border-radius: 8px;
  background-color: var(--color-neutral-light);
  opacity: 1;
}
@media screen and (max-width: 320px) {
  .banner-mobile-container {
    padding-bottom: var(--spacing-regular);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Hero/HeroStyles.less"],"names":[],"mappings":"AAOA;EACE,qCAAA;AANF;AAKA;EAGI,oCAAA;AALJ;AAMI;EAAA;IACE,iBAAA;EAHJ;AACF;AAII;EAAA;IACE,iBAAA;EADJ;AACF;AARA;EAYI,cAAA;AADJ;AAXA;EAoBc,iCAAA;AANd;AAdA;EAsBgB,wBAAA;EACA,uBAAA;EACA,uBAAA;AALhB;AAnBA;;EA4BgB,uBAAA;AALhB;AAvBA;EAkCgB,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AARhB;AA7BA;EA2Cc,8BAAA;AAXd;AAhCA;;EA8CgB,aAAA;AAVhB;AApCA;EAiDgB,wBAAA;EACA,uBAAA;EACA,uBAAA;AAVhB;AAzCA;EAsDgB,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAVhB;AAcY;EAAA;IAGM,wCAAA;EAbhB;AACF;AAmBQ;EAAA;IACE,iBAAA;EAhBR;AACF;AAzDA;EA8EQ,aAAA;EACA,QAAA;AAlBR;AAoBQ;EACE,oBAAA;AAlBV;AAqBY;EAQE,kBAAA;AA1Bd;AAkBY;EAEI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;AAjBhB;AAOQ;EAgBM,WAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;EACA,UAAA;AApBd;AA8BE;EAAA;IACE,sCAAA;EA3BF;AACF","sourcesContent":["@breakpoint-xs: 480px;\n@breakpoint-sm: 576px;\n@breakpoint-md: 768px;\n@breakpoint-lg: 992px;\n@breakpoint-xl: 1200px;\n@breakpoint-xxl: 1600px;\n\n.hero {\n  margin-bottom: var(--spacing-regular);\n  .VertCarousel-Container {\n    padding-bottom: var(--spacing-small);\n    @media screen and (min-width: @breakpoint-xl) {\n      max-height: 407px;\n    }\n    @media screen and (min-width: @breakpoint-sm) and (max-width: @breakpoint-xl) {\n      max-height: 407px;\n    }\n  }\n  .ant-carousel {\n    line-height: 0;\n\n    .vert-carousel {\n      .slick-list {\n        .slick-track {\n          .slick-slide {\n            // DESKTOP\n            .desktop-banners {\n              padding-top: var(--spacing-small);\n              a {\n                display: flex !important;\n                justify-content: center;\n                width: 100vw !important;\n              }\n              .ant-image .ant-image-img,\n              .lazy-image {\n                height: auto !important;\n              }\n       \n              \n              \n              .lazy-image {\n                display: block;\n                margin: 0 auto;\n                width: 100%;\n                height: 100%;\n              }\n            }\n\n            // MOBILE\n            .mobile-banners {\n              margin: var(--spacing-small) 0;\n              .ant-image .ant-image-img,\n              .lazy-image {\n                height: 160px;\n              }\n              a {\n                display: flex !important;\n                justify-content: center;\n                width: 100vw !important;\n              }\n              .lazy-image {\n                display: block;\n                margin: 0 auto;\n                width: 100%;\n                height: 100%;\n              }\n            }\n\n            @media screen and (min-width: @breakpoint-xxl) {\n              .desktop-banners {\n                .image {\n                  border-radius: var(--border-radius-base);\n                }\n              }\n            }    \n          }\n        }\n\n        @media screen and (max-width: @breakpoint-sm) {\n          max-height: 180px;\n        }\n      }\n\n      // DOTS\n      .slick-dots {\n        display: flex;\n        gap: 8px;\n\n        &.slick-dots-bottom {\n          margin-bottom: -30px;\n\n          li {\n            &.slick-active {\n              button {\n                width: 56px;\n                height: 4px;\n                border-radius: 8px;\n                margin-right: 20px;\n                background-color: var(--color-detached);\n              }\n              margin-right: 30px;\n            }\n\n            button {\n              width: 21px;\n              height: 4px;\n              border-radius: 8px;\n              background-color: var(--color-neutral-light);\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }   \n  }\n}\n\n.banner-mobile-container {\n  @media screen and (max-width: 320px) {\n    padding-bottom: var(--spacing-regular);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
